export default __webpack_public_path__ + "static/media/gridview.75deeeeb.png";